import { useMemo } from "react";
import { events } from "src/components/event-selector/EventSelector";

export default function useGetEventByType(type: string) {
  const event: undefined | (typeof events)[0] = useMemo(() => {
    if (type === "custom") return;
    return events.find((event) => event.type === type);
  }, [type]);

  return event;
}
